import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../services';
import { Subject, combineLatest } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AdobeService } from '../../../services/adobe.service';
import { IAMPMigratePreviewResponse, IAMPTransferResponse, IAdobeMigrationResponse } from '../../../models/amp.model';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { AMPSubTransferFinishComponent } from '../../../popup-collection/amp-sub-transfer-finish/amp-sub-transfer-finish.component';
import { ApiResponse } from '../../../models/api-response.model';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-vip-market-place-migrations',
  templateUrl: './vip-market-place-migrations.component.html',
  styleUrls: ['./vip-market-place-migrations.component.css']
})
export class VIPMarketPlaceMigrationsComponent implements OnInit {

  @ViewChild('tabs', {static: false}) tabGroup: MatTabGroup;

  title: string = "VIP Market Place Migrations";
  userFormGroup: FormGroup = this.formBuilder.group({
    membershipId: new FormControl("", Validators.compose([Validators.required])),
    ignoreOrderReturnControl: new FormControl(false),
    expirePurchaseAuthorizations: new FormControl(false)
  });
  loadContent: boolean = false;
  private resellerId: string;
  public showHVDDisclaimer = false;
  programType: string;
  tenantId: string = '';
  selectedPayment: string = '';
  preivewLoading = false;
  disableRequest = false;
  ignoreOrderReturnControl = new FormControl(false);
  expirePurchaseAuthorizations = new FormControl(false);
  public showTransferButton = false;
  public showNoResult = false;
  public displayedColumns: string[] = [
    'stkDesc',
    'offerId',
    'renewalDate',
    'quantity'
  ];
  public inProcessDisplayedColumns: string[] = [
    'transferId',
    'membershipId',
    'creationDate',
    'status'
  ];
  public archiveDisplayedColumns: string[] = [
    'transferId',
    'membershipId',
    'creationDate',
    'status',
    'manageButton'
  ];
  user_validation_messages: any = {
    "membershipId": [
      { class: "membershipIdValidate", message: "Please enter membership ID" }
    ]
  };
  previewResult: IAMPMigratePreviewResponse[]
  inProcessResult: IAdobeMigrationResponse[]
  archiveResult: IAdobeMigrationResponse[]
  ngUnsubscribe: Subject<void> = new Subject<void>();
  public consentCheckboxControl = this.formBuilder.group({
    consentControl: this.formBuilder.array([])
  });

  get consents() {
    return this.consentCheckboxControl.get('consentControl') as FormArray;
  }

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private adobeService: AdobeService,
    private dialog: MatDialog,
    public authService: AuthService
  ) { }

  ngOnInit() {
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    combineLatest([
      this.adobeService.getCurrentAMPResellerId
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        ([resellerId]) => {
          this.resellerId = resellerId;
        },
        (error: any) => {
          console.error(error);
        }
      );
  }

  transferPreview() {
    if (this.userFormGroup.get('membershipId').valid) {
      this.preivewLoading = true;
      this.adobeService
        .AMPSubscriptionsTransferPreview(
          this.userFormGroup.get('membershipId').value,
          this.userFormGroup.get('ignoreOrderReturnControl').value,
          this.userFormGroup.get('expirePurchaseAuthorizations').value
        )
        .pipe(
          finalize(() => {
            this.preivewLoading = false
          }),
          takeUntil(this.ngUnsubscribe)
        )
        .subscribe({
          next: (res: any) => {
            if ('responseMessage' in res && !(res as ApiResponse)?.status ) {
              this.commonService.implementToast(res.responseMessage, 'Error');
            } else {
              this.showTransferButton = true;
              this.previewResult = [ ...(res.items as IAMPMigratePreviewResponse[]) ]

              this.showHVDDisclaimer = res?.discounts?.find(x => x.offerType === 'LICENSE')?.discountCode != null;

              // setting up dynamic checboxes list for consents
              res?.consent?.forEach(value => {
                this.consents.push(this.formBuilder.group({
                  isActive: false,
                  name: value
                }))
              })
              
              if (!this.previewResult.length) this.showNoResult = true
            }
          },
          error: (error: any) => {
            this.commonService.implementToast(error, 'Error');
          }
        });
    } else {
      this.isNotValidField("membershipId", this.user_validation_messages.membershipId);
    }
  }


  isNotValidField(path: string, validation: any): void {
    if (path == "requestedBy") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  goToCustomer(e: IAdobeMigrationResponse) {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP/AMPDetails/' + e.customerId);
  }

  transferSubscriptions() {
    this.preivewLoading = true;
    this.disableRequest = true;
    this.adobeService.AMPTransferSubscriptions(
        this.resellerId, 
        this.userFormGroup.get('membershipId').value,
        this.userFormGroup.get('ignoreOrderReturnControl').value,
        this.userFormGroup.get('expirePurchaseAuthorizations').value
      )
      .pipe(
        finalize(() => {
          this.preivewLoading = false;
          this.disableRequest = false;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (res: IAMPTransferResponse) => {
          if (res?.transferId) {
            this.dialog.open(AMPSubTransferFinishComponent, {
              width: '500px',
              data: res
            })
            .afterClosed().subscribe(result => {
              if (result) {
                this.resetPage();
                this.tabGroup.selectedIndex = 1
              }
            })
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }

  public resetPage(): void {
    this.preivewLoading = false;
    this.disableRequest = false;
    this.showTransferButton = false;
    this.previewResult = [];
    this.userFormGroup.get('membershipId').setValue('');
    this.userFormGroup.get('ignoreOrderReturnControl').setValue(false);
    this.userFormGroup.get('expirePurchaseAuthorizations').setValue(false);
    this.consentCheckboxControl = this.formBuilder.group({
      consentControl: this.formBuilder.array([])
    });
  }
  
  myTabSelectedTabChange(event: MatTabChangeEvent) {
    const tabName = event.tab.textLabel;
    if (tabName == 'In-Process' || tabName == 'Archive') {
      this.preivewLoading = true;
      this.adobeService.getAdobeMigrationData(tabName).subscribe((res: IAdobeMigrationResponse[]) => {
        if (tabName == 'In-Process') {
          this.inProcessResult = res
        }
        if (tabName == 'Archive') {
          this.archiveResult = res
        }
        this.preivewLoading = false;
      },
        (error: any) => {
          console.error(error);
          this.preivewLoading = false;
          this.disableRequest = false;
        });
    }
  }

  check(e: any) {
    e.preventDefault();
  }

  hasUncheckedConsent(): boolean {
    const unchecked = this.consents.value.filter(chk => !chk.isActive);
    return unchecked.length ? true : false
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP');
  }
}
